import PropTypes from 'prop-types';
import { useRef } from 'react';

import Sidebar from 'components/Sidebar';
import SidebarStoresWithFeaturedCoupons from 'components/Sidebar/HighlightedStores/V1';
import SidebarHowPromobitWorks from 'components/Sidebar/HowPromobitWorks';

const LandingSidebar = ({
  gaEventCategory,
  storesWithFeaturedCoupons = [],
}) => {
  const howPromobitWorksRef = useRef(null);
  const storesWithFeaturedCouponsRef = useRef(null);

  return (
    <Sidebar
      className="mb-4 mt-10 gap-y-4 xl:mt-0"
      refsToBeIgnoredBeforeFixing={[
        howPromobitWorksRef,
        storesWithFeaturedCouponsRef,
      ]}
    >
      <SidebarHowPromobitWorks
        ref={howPromobitWorksRef}
        gaEventCategory={gaEventCategory}
      />
      {storesWithFeaturedCoupons.length > 0 && (
        <SidebarStoresWithFeaturedCoupons
          ref={storesWithFeaturedCouponsRef}
          stores={storesWithFeaturedCoupons}
        />
      )}
    </Sidebar>
  );
};

LandingSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  storesWithFeaturedCoupons: PropTypes.arrayOf(
    PropTypes.shape({
      storeName: PropTypes.string,
      storeSlug: PropTypes.string,
    }).isRequired
  ),
};

export default LandingSidebar;
